import React from 'react';
import { Form } from 'semantic-ui-react';
import TagDropdown from './TagDropdown';
import FilterDropdownItem from './FilterDropdownItem'
import PropTypes from 'prop-types';

const FilterTagBar = (props) => {
  const getDropdownItem = (tag) => {
    return {
      key: tag,
      value: tag,
      text: tag,
      content: (
        <FilterDropdownItem tag={tag}/>
      )
    }
  }

  return (
    <div className="filter-bar">
      <Form className="container">
        <TagDropdown
          className="tag-dropdown-delete"
          dropdownItem={getDropdownItem}
          tagOptions={props.tagOptions}
          tagsSelected={props.tagsSelected}
          handleTagsUpdated={props.handleTagFilterUpdated}
          handleSearchUpdated = {props.handleSearchTextUpdated}
          placeholder={props.placeholder}
          noResultsMessage={'No tags by that name.'}
          allowAdditions={false}
          enableCloseAction={true}
          closeOnChange={true} />
      </Form>
    </div>
  );
}

FilterTagBar.propTypes = {
  tagsSelected: PropTypes.arrayOf(PropTypes.string).isRequired,
  tagOptions: PropTypes.arrayOf(PropTypes.string.isRequired),
  searchText: PropTypes.string,
  placeholder: PropTypes.string,
  handleSearchTextUpdated: PropTypes.func.isRequired,
  handleTagFilterUpdated: PropTypes.func.isRequired
}

FilterTagBar.defaultProps = {
  placeholder: 'Add tag'
}

export default FilterTagBar;



// WEBPACK FOOTER //
// ./src/components/FilterTagBar.js